<template>
    <div class="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 p-4 border-l-4"
        :class="borderColor">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
            <div class="flex-1">
                <h4 class="font-semibold text-gray-800 text-sm sm:text-base">{{ event.title }}</h4>
                <p class="text-xs sm:text-sm text-gray-600 mt-1">{{ event.description }}</p>
                <div class="flex items-center gap-2 mt-2">
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                        :class="institutionBadgeClass">
                        {{ event.entity }}
                    </span>
                    <span
                        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
                        {{ event.term }}
                    </span>
                </div>
            </div>
            <div class="text-right">
                <div class="text-sm font-medium text-gray-700">{{ event.dateRange }}</div>
                <div class="text-xs text-gray-500 mt-1">{{ formatDuration(event.startDate, event.endDate) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "academic-calendar-card",
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    computed: {
        borderColor() {
            const colorMap = {
                '#f97316': 'border-orange-500',
                '#10b981': 'border-green-500',
                '#3b82f6': 'border-blue-500'
            };
            return colorMap[this.event.color] || 'border-gray-400';
        },
        institutionBadgeClass() {
            const classMap = {
                'ADPOLY': 'bg-orange-100 text-orange-800',
                'FCHS': 'bg-blue-100 text-blue-800'
            };
            return classMap[this.event.entity] || 'bg-gray-100 text-gray-800';
        }
    },
    methods: {
        formatDuration(startDate, endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const diffTime = Math.abs(end - start);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            if (diffDays === 0) {
                return 'Single day';
            } else if (diffDays === 1) {
                return '1 day';
            } else {
                return `${diffDays} days`;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// Additional styling if needed</style>
